import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { UserActions, ConsultationsActions, NavigationActions } from '../actions';
import { SignIn } from  '../components'

class SignInScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
    }
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align sign-in-page">
        <SignIn
          userActions={this.props.userActions}
          consultationsActions={this.props.consultationsActions}
          navigationActions={NavigationActions}
        />
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    userActions: bindActionCreators(
     { ...UserActions }, dispatch),
    consultationsActions: bindActionCreators(
     { ...ConsultationsActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInScreen)
